import { getFieldState } from "src/components/10-atoms/form/hooks/useFieldState/utils";
import useFormState from "src/components/10-atoms/form/hooks/useFormState";
import useStableCallback from "src/hooks/useCallbackUtils/useStableCallback";
import useContributionResponseHandler from "src/modules/exam-preparation/containers/ContributionResponseHandler/useContributionResponseHandler";
import { useUploadEFMutation } from "src/modules/exam-preparation/graphql/ef/upload";
import { useQPDetailsQuery } from "src/modules/exam-preparation/graphql/qp/getDetails";
export default function useData(qpID) {
    const [qpDetailsQueryState] = useQPDetailsQuery(qpID);
    const [uploadMutationState, uploadMutationActions] = useUploadEFMutation();
    const [formState, formActions] = useFormState({
        fields: {
            efImages: getFieldState([]),
        },
    }, {
        fieldValidations: {
            efImages({ value }) {
                if (value.length === 0) {
                    return 'Please upload Examiners Feedback images';
                }
                if (value.length > 20) {
                    return 'You can only include upto 20 images';
                }
                return true;
            },
        },
    });
    const handleSubmit = useStableCallback(async () => {
        if (formState.fields.efImages.value.length === 0) {
            return;
        }
        uploadMutationActions.submit({
            variables: {
                data: {
                    qpID,
                    efImages: formState.fields.efImages.value.map(efImage => ({
                        uri: efImage.uploadRequest.data.publicURL,
                    })),
                },
            },
        });
    });
    const [, contributionResponseHandler] = useContributionResponseHandler({
        sentForReviewContent: {
            title: 'Examiners Feedback sent for review 🎉',
            howItWorksSteps: [
                'MarineSamraj team will review & digitalize the Examiners Feedback',
            ],
        },
        thankContributorContent: {
            title: 'Examiners Feedback uploaded successfully 🎉',
        },
    });
    const state = {
        uploadMutation: uploadMutationState,
        form: formState,
        qpDetailsQuery: qpDetailsQueryState,
    };
    const actions = {
        uploadMutation: uploadMutationActions,
        form: formActions,
        handleSubmit,
        contributionResponseHandler,
    };
    return [state, actions];
}
